import {PILL_CLASS} from '../pill/constants'


// Mirror image of `textareaWithVariables_parseValueToDOM`. Walks the
// editor DOM and reconstructs the stored value:
//   - pill spans → their `data-token` attribute (the literal `{TOKEN}`)
//   - `<br>`     → `\n`
//   - text nodes → text, with INTER_PILL_SPACER zero-width chars stripped
//   - block elements (`<div>`, `<p>`) → treated as line boundaries
//     (some browsers wrap on Enter; we want round-trip parity)
//
// Invariant: parseValueToDOM(value) followed by serializeDOMToValue
// yields back the same `value` (modulo `\n` ↔ `<br>` equivalence).
export function textareaWithVariables_serializeDOMToValue(root: Node): string {
    let out = ''

    const walk = (node: Node) => {
        if (node.nodeType === Node.TEXT_NODE) {
            // INTER_PILL_SPACER is a render-only zero-width char —
            // strip it so it never leaks into stored values / backend.
            out += (node.textContent || '').replace(/​/g, '')
            return
        }
        if (node.nodeType !== Node.ELEMENT_NODE) return

        const el = node as HTMLElement
        if (el.tagName === 'BR') {
            out += '\n'
            return
        }
        if (el.classList.contains(PILL_CLASS)) {
            out += el.getAttribute('data-token') || ''
            return
        }
        // Browser may auto-wrap on Enter into <div>/<p> — treat each
        // block boundary as a newline so the serialised value matches
        // what the user sees. Skip if we're at the start, or already
        // ended on a newline (avoids double-`\n` between adjacent blocks).
        const isBlock = el.tagName === 'DIV' || el.tagName === 'P'
        if (isBlock && out.length > 0 && !out.endsWith('\n')) out += '\n'

        for (const child of Array.from(el.childNodes)) walk(child)
    }

    for (const child of Array.from(root.childNodes)) walk(child)
    return out
}
